import { Ability } from '@casl/ability';
import { permissions } from './permissionsMapping';

export default new Ability([]);

export const defineRules = userRights => {
  return userRights.map(right => permissions[right]).filter(i => i);
};
